<syslink-grid
    #grid
    [permissionKey]="'list'"
    [gridName]="storageKey"
    [canView]="canView"
    [canSearch]="canSearch"
    [canRefresh]="canRefresh"
    [canAdd]="canAdd"
    [canSort]="canSort"
    [canFilter]="canFilter"
    [canExport]="canExport"
    [canDblClck]="canDblClck"
    [service]="mailTemplatesService"
    [expand]="expand"
    [storageKey]="storageKey"
    [columns]="columns"
    [expand]="expand"
    [canUpdate]="false"
    [canDelete]="canDelete"
    (add)="add.emit()"
    (doubleClick)="doubleClick.emit($event)"
></syslink-grid>